import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
export default class ComponentToPrint extends React.Component {

  render() {
    const farmerDetails = this.props.farmerDetails;
    const data = this.props.searchData;

    return (
      <div align='left'>
        <h3><center><u>Supplier Onboarding Details</u></center></h3>
        <div >&nbsp;</div>
        {/* <h4><center>Group - {data.groupID} </center></h4>
        <h4><center>Fresh Collection Center - {data.factoryID}</center></h4>
        <h4><center>Status - {data.statusID == 1 ? 'New' : data.statusID == 2 ? 'FCC Approved' : data.statusID == 3 ? 'FDC First Approved' : data.statusID == 4 ? 'FDC Second Approved' :
          data.statusID == 5 ? 'FCC Rejected' : data.statusID == 6 ? 'FDC First Rejected' : data.statusID == 7 ? 'FDC Second Rejected' : 'All Status'}</center></h4> */}
        <div>&nbsp;</div>
        <Box minWidth={1150}>

          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Fresh Collection Center</TableCell>
                  <TableCell align="center">Supplier Code Agrithmics</TableCell>
                  <TableCell align="center">Supplier Code -Navision</TableCell>
                  <TableCell align="center">Preferred Name</TableCell>
                  <TableCell align="center">FCC Approval status</TableCell>
                  <TableCell align="center">FCC Approve / Reject User Name</TableCell>
                  <TableCell align="center">FDC Approval status</TableCell>
                  <TableCell align="center">FDC Approve / Reject User Name</TableCell>
                  <TableCell align="center">Last Updated Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {farmerDetails.map((row) => (
                  <TableRow key={row.farmerCode}>
                    <TableCell align="center">
                      {row.collectionCenterName}
                    </TableCell>
                    <TableCell align="center">
                      {row.farmerCode}
                    </TableCell>
                    <TableCell align="center">
                      {row.navisionNumber == null ? '-' : row.navisionNumber}
                    </TableCell>
                    <TableCell align="center">
                      {row.preferedName}
                    </TableCell>
                    <TableCell align="center">
                      {row.farmerStatus == 1 ? <Chip size="small" label="New" style={{ color: 'green' }} />
                        : row.farmerStatus == 2 || (row.fccApprovalStatus == 2) ? <Chip size="small" label="FCC Approved" style={{ color: 'orange' }} />
                          : row.farmerStatus == 5 || row.fccApprovalStatus == 5 ? <Chip size="small" label="FCC Rejected" style={{ color: 'red' }} />
                            : '-'
                      }
                    </TableCell>
                    <TableCell align="center">
                      {(row.farmerStatus == 1 || row.farmerStatus == 2 || row.farmerStatus == 5 || row.fccApprovalStatus == 2 || row.fccApprovalStatus == 5) ? row.fccApprovalUser : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.farmerStatus == 3 ? <Chip size="small" label="FDC First Approved" style={{ color: '#B414F9' }} />
                        : row.farmerStatus == 4 ? <Chip size="small" label="FDC Second Approved" style={{ color: 'blue' }} />
                          : row.farmerStatus == 6 ? <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                            : row.farmerStatus == 7 ? <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                              : '-'
                      }
                    </TableCell>
                    <TableCell align="center">
                      {(row.farmerStatus == 3 || row.farmerStatus == 4 || row.farmerStatus == 6 || row.farmerStatus == 7) ? row.fdcApprovalUser : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {(row.lastUpdatedTime).split('T')[0]}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
